const heroModule = {
  id: "AD8A370C-F838-4B90-A063-D63AF809AF1E",
  config: {
    general: {
      media: {
        url: "https://tc-media.job-shop.com/content-modules/cover/header/cover-header.jpg",
        mediaType: "image",
      },
      showMedia: false,
      showSubtitle: true,
      backgroundColor: {
        label: "White",
        value: "#ffffff",
      },
    },
    media: {
      media: {
        url: "https://tc-media.job-shop.com/content-modules/cards/card/image/card-image.jpg",
        mediaType: "image",
      },
      mediaAltText: "Awesome image",
      corners: {
        label: "Round",
        value: "round",
      },
    },
    header: {
      textColor: {
        label: "Black",
        value: "#000000",
      },
      isTextInCaps: false,
    },
    subtitle: {
      textColor: {
        label: "Grey",
        value: "#86868b",
      },
      isTextInCaps: false,
    },
    jobDetails: {
      options: [
        {
          active: true,
          key: "company",
          label: "Company",
        },
        {
          active: true,
          key: "department",
          label: "Department",
        },
        {
          active: true,
          key: "location",
          label: "Location",
        },
        {
          active: true,
          key: "schedule",
          label: "Work Schedule",
        },
        {
          active: true,
          key: "start_year",
          label: "Start Year",
        },
        {
          active: true,
          key: "career_level",
          label: "Career Level",
        },
        {
          active: true,
          key: "working_hours",
          label: "Working Hours",
        },
        {
          active: false,
          key: "work_mode",
          label: "Work Mode",
        },
        {
          active: false,
          key: "custom_filter_1",
          label: "Custom Filter 1",
        },
        {
          active: false,
          key: "custom_filter_2",
          label: "Custom Filter 2",
        },
        {
          active: false,
          key: "custom_filter_3",
          label: "Custom Filter 3",
        },
        {
          active: false,
          key: "custom_filter_4",
          label: "Custom Filter 4",
        },
        {
          active: false,
          key: "custom_filter_5",
          label: "Custom Filter 5",
        },
        {
          active: false,
          key: "custom_filter_6",
          label: "Custom Filter 6",
        },
        {
          active: false,
          key: "country",
          label: "Country",
        },
        {
          active: false,
          key: "cluster",
          label: "Cluster",
        },
        {
          active: true,
          key: "contract_type",
          label: "Contract Type",
        },
      ],
      textColor: {
        label: "Black",
        value: "#000000",
      },
      backgroundColor: {
        label: "Light Grey",
        value: "#f5f5f5",
      },
      showFullAddress: false,
    },
    applyButton: {
      text: "Apply Now",
      backgroundColor: {
        label: "Blue",
        value: "#007bff",
      },
      textColor: {
        label: "White",
        value: "#ffffff",
      },
      fillStyle: {
        label: "Fill",
        value: "fill",
      },
      corners: {
        label: "Round",
        value: "round",
      },
      link: {
        type: {
          label: "External Link",
          value: "external",
        },
        url: "https://example.com",
        scrollTarget: {
          label: "Hero",
          value: "da6346f5-8e12-4eb2-bf6f-3fe503a42afa",
        },
        target: {
          label: "New Tab",
          value: "_blank",
        },
      },
    },
    pitchYouButton: {
      text: "Apply with WhatsApp",
      useCustomColor: false,
      backgroundColor: {
        label: "Blue",
        value: "#007bff",
      },
      textColor: {
        label: "White",
        value: "#ffffff",
      },
      fillStyle: {
        label: "Fill",
        value: "fill",
      },
      corners: {
        label: "Round",
        value: "round",
      },
      link: {
        type: {
          label: "External Link",
          value: "external",
        },
        url: "",
        scrollTarget: {
          label: "",
          value: "",
        },
        target: {
          label: "New Tab",
          value: "_blank",
        },
      },
    },
  },
};

export default heroModule;
